<template>
  <custom-dialog class="login-overlay" @dialog-closed="handleClose">
    <template v-if="showCreateAccount">
      <h1 class="login-overlay__headline">
        Create Account
      </h1>
      <social-login
        class="login-overlay__social-logins"
        login-mode="register" />
      <mid-bar-text class="login-overlay__bar-text">
        Or with Email
      </mid-bar-text>
      <create-account-form emit-event @login-successful="handleLoginSuccess" />
      <mid-bar-text class="login-overlay__bar-text">
        Already have an account?
      </mid-bar-text>
      <div class="login-overlay__links">
        <button class="login-overlay__button" @click.stop="showLoginForm">
          Login
        </button>
      </div>
    </template>
    <template v-else>
      <h1 class="login-overlay__headline">
        Login
      </h1>
      <slot />
      <social-login
        class="login-overlay__social-logins"
        login-mode="login" />
      <mid-bar-text class="login-overlay__bar-text">
        Or with Mail
      </mid-bar-text>
      <login-form
        emit-event
        @login-successful="handleLoginSuccess" />
      <mid-bar-text class="login-overlay__bar-text">
        New to A Sound Effect?
      </mid-bar-text>
      <div class="login-overlay__links">
        <button class="login-overlay__button" @click.stop="showCreateAccountForm">
          Create New Account
        </button>
      </div>
    </template>
  </custom-dialog>
</template>

<script setup lang="ts">
import LoginForm from "~/components/parts/login/LoginForm.vue";
import MidBarText from "~/components/UI/MidBarText.vue";
import SocialLogin from "~/components/parts/login/SocialLogin.vue";
import CustomDialog from "~/components/parts/CustomDialog.vue";
import CreateAccountForm from "~/components/parts/login/CreateAccountForm.vue";
import { ref } from "#imports";

const showCreateAccount = ref(false);

const emit = defineEmits(['cancel-close', 'login-successful']);

const handleClose = () => {
  emit('cancel-close');
}
const handleLoginSuccess = () => {
  emit('login-successful');
}
const showCreateAccountForm = () => {
  showCreateAccount.value = true;
}
const showLoginForm = () => {
  showCreateAccount.value = false;
}
</script>

<style lang="scss">
@use "~/common/scss/page";

.login-overlay {
  @include page.smallFormPage();

  text-align: center;
}

.login-form__group {
  display: flex;
  flex-direction: column;
}

.login-form__group-label {
  display: none !important;
}
</style>
